import React, { useState, useEffect } from "react";
import { Button, TextField, InputLabel } from "@material-ui/core";
import Schedular from "./Schedular";
import "../style.css";
import GTLabel from "components/GTLabel";
import Container from "containers/anx1/SharedModule/DropdownTreeContainer";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchNoticeData,
  getNoticeTableData,
  getSchedularList,
  setSelectedDate,
  setSelectedGstin,
  fetchNoticesBulk,
  getEntityList,
  getGstinByEntity,
  setSelectedEntity,
  setProfileData,
  setGstinList,
  getFetchHistory,
} from "./action";
// import clock from "./clock.svg";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import { errorToastMessage } from "utils/errorToast";
import { COMMON_MSGS } from "Constant/Messages";
import DatePicker from "react-datepicker";
import { formatDateToDDMMYYYY } from "../Utility/utilis";
// import SingleSelect from "components/Select/SingleSelect";
import CustomSelect from "../Utility/CustomSelect";
import { headerColumns } from "containers/gstr2a2bNewEnhancement/Fetch/constants";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import { Badge } from "@material-ui/core";

export default function Header(props) {
  const [hoverCount, setHoverCount] = useState(0);

  const handleHover = () => {
    setHoverCount((prev) => prev + 1);
  };

  const {
    gstinList,
    selectedDate,
    selectedGstin,
    entityList,
    selectedEntity,
    profileData,
  } = useSelector((state) => state.noticeReducer);

  const [ShowSchedular, setShowSchedular] = useState(false);
  const [profile, setProfile] = useState([]);
  const dispatch = useDispatch();

  const handleSchedular = async () => {
    try {
      const response = await dispatch(getSchedularList());
      // if (response) setShowSchedular(true);
      setShowSchedular(true);
    } catch (error) {
      console.log("Error in handleSchedular:", error);
    }
  };

  const handleClosePopup = () => {
    setShowSchedular(false);
  };

  const handleGstin = (currentNode, selectedNodes) => {
    let gstArr = [];
    if (selectedNodes[0]?.label === "All GSTIN") {
      var newProfile =
        profileData.length > 0
          ? profileData.map((v) => ({
              ...v,
              label: v.gstin || v.GSTIN,
              value: v.gstin || v.GSTIN,
            }))
          : [];
      gstArr = newProfile?.map((item) => {
        return item.gstin;
      });
    } else {
      gstArr = selectedNodes.map((item) => {
        return item.gstin || item.GSTIN || item.value || item.label;
      });
    }
    dispatch(setSelectedGstin(gstArr));
    // console.log("Selected GSTINs:", gstArr);
  };

  const handleDateChange = (e) => {
    dispatch(setSelectedDate(e.target.value));
  };

  const getEntityMasterList = () => {
    return (
      entityList?.map((item) => ({
        ...item,
        checked: item.value === selectedEntity,
      })) || []
    );
  };

  const handleEntityChange = async (value) => {
    try {
      dispatch(setSelectedEntity(value || ""));
      dispatch(setSelectedGstin([])); // Reset GSTIN selection as array

      if (value) {
        await dispatch(getGstinByEntity(value));
      } else {
        dispatch(setProfileData([]));
        dispatch(setGstinList([]));
      }
    } catch (error) {
      console.log("Error in handleEntityChange:", error);
    }
  };

  const handleFetch = async () => {
    try {
      if (!selectedGstin || selectedGstin.length === 0 || !selectedDate) {
        return errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
      }

      // Format date to DD/MM/YYYY before sending
      const formattedDate = formatDateToDDMMYYYY(selectedDate);

      // selectedGstin is already an array
      const gstinList = selectedGstin;

      // Call the bulk fetch API
      const fetchedData = await dispatch(
        fetchNoticesBulk(gstinList, formattedDate)
      );

      if (fetchedData) {
        await props.fetchHistory();
        props.setPageNoHistory(1)
      }
    } catch (error) {
      console.log("Error in handleFetch:", error);
    }
  };

  useEffect(() => {
    let newProfile =
      profileData?.length > 0
        ? profileData.map((v) => ({ 
            ...v, 
            label: v.gstin,
            value: v.gstin,
            className: v.scheduled ? "gstin-scheduled" : ""
          }))
        : [];

    const AllProfile = [
      {
        label: "All GSTIN",
        value: "All GSTIN", 
        checked: false,
        tagClassName: "special",
        children: newProfile,
      },
    ];

    // console.log("Profile Data:", profileData);
    // console.log("Built Profile:", AllProfile);
    // console.log("Selected Entity:", selectedEntity);

    setProfile(AllProfile);
  }, [profileData]);

// useEffect(() => {
//    console.log('profile ------>',profile)
//    console.log('selectedEntity -------->',selectedEntity)
//   }, [profile]);
useEffect(() => {
   return ()=>{
    setProfile([]);
  dispatch(setProfileData([]));
  }
  }, []);

  return (
    <div className="notice-gstin-selector-section">
      <div
        // className="notice-select-entity"
        className="dropdown-container-notice"
        style={{ width: "20.5%",zIndex:101 }}
      >
        <label
          style={{
            fontFamily: "GT-Walsheim-medium",
            fontSize: "12px",
          }}
        >
          Select Entity*
        </label>
        <CustomSelect
          values={getEntityMasterList()}
          optionHeading="Select"
          selectedValue={selectedEntity || ""}
          handleChange={(e) => handleEntityChange(e.target.value)}
        />
      </div>

      <div
        className="dropdown-container-notice"
        style={{ width: "23%" ,zIndex:101}}

        // className="gstin-dropdown"
        // style={{ width: "20%", padding: "2px 0px 0px 0px", position: "sticky" }}
      >
        <label
          style={{
            fontFamily: "GT-Walsheim-medium",
            fontSize: "12px",
          }}
        >
          Select GSTIN *
        </label>
        {/* <Container
          data={gstinList?.map((gstin) => ({
            label: gstin,
            value: gstin,
            checked: false,
          }))}
          mode="simpleSelect"
          onChange={handleGstin}
          isDisabled={gstinList?.length === 0}
          searchable={true}
        /> */}
        <Container
          data={profile}
          onChange={handleGstin}
          mode="multiSelect"
                        isDisabled={profileData.length === 0}

          // isDisabled={!selectedEntity || profile.length === 0}
          searchable={true}
        />
      </div>
{props.activeTab === 1 && <>
<div className="notice-select-period-dropdown">
        <label
          style={{
            fontFamily: "GT-Walsheim-medium",
            fontSize: "12px",
          }}
        >
          Select From Date*
        </label>
        {/* <TextField
          id="date"
          type="date"
          value={selectedDate || ""}
          onChange={handleDateChange}
          style={{ width: "95%", marginTop: "1px", backgroundColor: "white" }}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            min: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000)
              .toISOString()
              .split("T")[0],
            max: new Date().toISOString().split("T")[0],
          }}
        /> */}
        <div className="notice-datepicker">
          <DatePicker
            showIcon
            selected={selectedDate}
            onChange={(date) => dispatch(setSelectedDate(date))}
            placeholderText="Select Date"
            minDate={new Date(Date.now() - 60 * 24 * 60 * 60 * 1000)}
            maxDate={new Date()}
            dateFormat="dd/MM/yyyy"
            popperProps={{
              strategy: "fixed",
            }}
            calendarClassName="notice-small-calendar"
            className="notice-date-picker-input"
          />
        </div>
      </div></>}
      

      <div className="notice-action-buttons" style={{ marginTop: "12px" }}>
        <div className="notice-button">
          <Button
            className="notice-header-button"
            style={{
              marginLeft: "1.8em",
            }}
            variant="contained"
            color="primary"
            onClick={
              props.activeTab === 1
                ? handleFetch
                : () => props.getTableData(1, "", true)
            }
          >
            {props.activeTab === 1 ? "Fetch" : "Submit"}
          </Button>
        </div>
        {props.activeTab === 2 && (
          // <></>
          <div className="notice-button">
            <Button
              className="notice-header-button"
              variant="contained"
              color="primary"
              onClick={handleSchedular}
            >
              <AccessTimeIcon
                style={{ width: "20px", height: "20px", marginRight: "5px" }}
              />
              Scheduler
            </Button>

            <Schedular open={ShowSchedular} onClose={handleClosePopup} />
          </div>
        )}
      </div>

      {/* <div onMouseEnter={handleHover} id="schedular-icon">
        <Badge badgeContent={hoverCount} color="secondary">
          <NotificationsActiveIcon className="bell-swing" />
        </Badge>
      </div> */}
    </div>
  );
}
